function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Badge } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { EditButton, DeleteButton, SaveButton, CancelButton } from '@rd-web-markets/shared/dist/util/buttons';
import { formatDateLocale } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import NotesAndAssumptionReviewSection from './NotesAndAssumptionReviewSection';
import ReviewHistoryToggle from './notesAndAssumptionReviews/ReviewHistoryToggle';
const NotesAndAssumptionsTableEnhanced = _ref => {
  var _formData$comments, _formData$expenditure;
  let {
    notes = [],
    categories = [],
    onUpdate,
    onDelete,
    userCanEdit,
    onReviewUpdate,
    loading,
    claimId,
    fetchNotes
  } = _ref;
  const {
    t
  } = useTranslation();
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({});
  const getCategoryLabel = category => {
    return t(category);
  };
  const handleEdit = (index, row) => {
    const note = row.note;
    setEditingNoteId(note.id);
    setFormData({
      comments: note.comments || '',
      expenditure_category: note.expenditure_category || ''
    });
  };
  const handleCancel = () => {
    setEditingNoteId(null);
    setFormData({});
  };
  const handleChange = (field, value) => {
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [field]: value
    }));
  };
  const handleSave = async note => {
    setSaving(true);
    try {
      await onUpdate({
        id: note.id,
        data: formData
      });
      setEditingNoteId(null);
      setFormData({});
    } catch (error) {
      console.error('Error updating note:', error);
    } finally {
      setSaving(false);
    }
  };
  const handleDelete = async (index, row) => {
    if (window.confirm(t('confirm_delete'))) {
      await onDelete(row.note.id);
    }
  };
  const canSave = ((_formData$comments = formData.comments) === null || _formData$comments === void 0 ? void 0 : _formData$comments.trim()) !== '' && ((_formData$expenditure = formData.expenditure_category) === null || _formData$expenditure === void 0 ? void 0 : _formData$expenditure.trim()) !== '';
  const headers = useMemo(() => [{
    text: t('date'),
    width: '15%'
  }, {
    text: t('created_by'),
    width: '15%'
  }, {
    text: t('category'),
    width: '15%'
  }, {
    text: t('comments'),
    width: '40%'
  }, {
    text: t('actions'),
    width: '15%'
  }], [t]);
  const rows = useMemo(() => {
    return notes.map(note => {
      var _note$active_reviews, _note$past_reviews;
      const isEditing = editingNoteId === note.id;
      const isSavingThisRow = saving && isEditing;
      console.log('Note processing:', {
        id: note.id,
        comments: note.comments.substring(0, 20),
        has_active_cost_review: note.has_active_cost_review,
        has_been_reviewed: note.has_been_reviewed,
        current_review: note.current_review,
        active_reviews_count: ((_note$active_reviews = note.active_reviews) === null || _note$active_reviews === void 0 ? void 0 : _note$active_reviews.length) || 0,
        past_reviews_count: ((_note$past_reviews = note.past_reviews) === null || _note$past_reviews === void 0 ? void 0 : _note$past_reviews.length) || 0
      });
      const hasActiveReview = note.has_active_cost_review;
      const hasPastReviews = note.past_reviews && note.past_reviews.length > 0;
      const isExpandable = hasActiveReview || hasPastReviews;
      const isExpanded = isExpandable;
      const columns = isEditing ? [/*#__PURE__*/React.createElement("small", {
        className: "text-muted"
      }, formatDateLocale(note.created_at)), /*#__PURE__*/React.createElement("small", null, note.created_by), /*#__PURE__*/React.createElement(Form.Select, {
        size: "sm",
        name: "expenditure_category",
        value: formData.expenditure_category,
        onChange: e => handleChange('expenditure_category', e.target.value)
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, t('select_category')), categories.map(category => /*#__PURE__*/React.createElement("option", {
        key: category,
        value: category
      }, getCategoryLabel(category)))), /*#__PURE__*/React.createElement(Form.Control, {
        as: "textarea",
        rows: 3,
        size: "sm",
        name: "comments",
        value: formData.comments,
        onChange: e => handleChange('comments', e.target.value),
        placeholder: t('enter_comments')
      }), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, /*#__PURE__*/React.createElement(SaveButton, {
        size: "sm",
        onClick: () => handleSave(note),
        disabled: isSavingThisRow || !canSave,
        text: isSavingThisRow ? t('saving') : t('save')
      }), /*#__PURE__*/React.createElement(CancelButton, {
        size: "sm",
        onClick: handleCancel,
        disabled: isSavingThisRow
      }))] : [/*#__PURE__*/React.createElement("small", {
        className: "text-muted"
      }, formatDateLocale(note.created_at)), /*#__PURE__*/React.createElement("small", null, note.created_by), /*#__PURE__*/React.createElement(Badge, {
        bg: "primary"
      }, getCategoryLabel(note.expenditure_category)), /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, /*#__PURE__*/React.createElement("small", null, note.comments)), userCanEdit && !hasActiveReview ? /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, /*#__PURE__*/React.createElement(EditButton, {
        size: "sm",
        onClick: () => handleEdit(null, {
          note
        })
      }), /*#__PURE__*/React.createElement(DeleteButton, {
        size: "sm",
        onClick: () => handleDelete(null, {
          note
        })
      })) : null];
      return {
        key: "".concat(note.id, "-").concat(isEditing ? 'edit' : 'view', "-").concat(hasActiveReview ? 'active' : 'inactive'),
        note: note,
        columns: columns,
        expandable: !isEditing && isExpandable,
        expanded: !isEditing && isExpanded,
        renderExpandedContent: row => {
          const rowNote = row.note;
          const showActiveReview = rowNote.has_active_cost_review;
          const showPastReviews = rowNote.past_reviews && rowNote.past_reviews.length > 0;
          return /*#__PURE__*/React.createElement("div", {
            className: "px-3 py-3"
          }, showActiveReview && /*#__PURE__*/React.createElement(NotesAndAssumptionReviewSection, {
            note: rowNote,
            onReviewUpdate: onReviewUpdate,
            loading: loading,
            claimId: claimId
          }), showPastReviews && /*#__PURE__*/React.createElement(ReviewHistoryToggle, {
            pastReviews: rowNote.past_reviews
          }));
        }
      };
    });
  }, [notes, editingNoteId, formData, userCanEdit, categories, saving, loading, claimId, onReviewUpdate, t]);
  return /*#__PURE__*/React.createElement("div", {
    className: "notes-and-assumptions-table"
  }, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false,
    opts: {
      bordered: false,
      striped: true,
      responsive: true,
      hover: true,
      headerSticky: true
    },
    style: {
      borderCollapse: 'collapse'
    }
  }));
};
export default NotesAndAssumptionsTableEnhanced;